import React from "react";

export type MenuConsultaProdutosProps = {
  // 4557575 permitirVisualiarSimulacaoDePreco: boolean
  permitirVisualiarEstoque: boolean
  permitirVisualiarAgregadosESugerirProdutos: boolean
  permitirVisualiarSimilares: boolean
  permitirVisualiarOfertas: boolean
  permitirVisualiarLotesProdutos: boolean
  permitirVisualiarLotesProdutosReservados: boolean
  permitirVisualiarTributacao: boolean
  permitirVisualiarMovimentacaoEstoque: boolean
  permitirVisualizarUltimasCompras: boolean
  permitirVisualiarMedidasMadeira: boolean
  orcamentoControlaValidade: boolean
  permitirVisualizarConsultaTinta: boolean
  permitirVisualiarAnaliseGerencial: boolean // 433081
  permitirVisualizarOrdemProducao: boolean
  //457575 -- onRenderizarConsultaSimulacaoDePreco: () => void
  onRenderizarConsultaEstoque: () => void
  onRenderizarConsultaAgregados: () => void
  onRenderizarConsultaSimilares: () => void
  onRenderizarConsultaOfertas: () => void
  onRenderizarConsultaLotesProdutos: () => void
  onRenderizarConsultaLotesProdutosReservados: () => void
  onRenderizarConsultaSugerirProdutos: () => void
  onRenderizarConsultaTributacao: () => void
  onRenderizarConsultaMovimentacaoEstoque: () => void
  onRenderizarConsultaUltimasCompras: () => void
  onRenderizarConsultaMedidasMadeira: () => void
  onRenderizarConsultaTinta: () => void
  onRenderizarConsultaOrdemProducao: () => void
  onRenderizarConsultaAnaliseGerencial: () => void // 433081
  // onRenderizarConsultaServicosAgregados: () => void
  onSelecionadoMenu: () => void;
};

export const MenuConsultaProdutos = (props: MenuConsultaProdutosProps) => {

  return (
    <>
      <h2>Consultas</h2>

      <ul>
        
        { /* --- PA 457575
        props.permitirVisualiarSimulacaoDePreco && (
          <li>
            <a href="#"
              onClick={() => {
                props.onRenderizarConsultaSimulacaoDePreco()
                props.onSelecionadoMenu();
              }}
              id="MenuConsultaProdutos_SimulacaoDePreco">
              Simulação de Preço
            </a>
          </li>
        )
        */
        }

        {props.permitirVisualiarEstoque && (

          <li>
            <a href="#"
              onClick={() => {
                props.onRenderizarConsultaEstoque()
                props.onSelecionadoMenu();
              }}
              id="MenuConsultaProdutos_Estoque">
              Estoque
            </a>
          </li>
        )}

        {props.permitirVisualiarAgregadosESugerirProdutos && (

          <li>
            <a href="#"
              onClick={() => {
                props.onRenderizarConsultaAgregados()
                props.onSelecionadoMenu();
              }}
              id="MenuConsultaProdutos_AgregadosESugerirProdutos">
              Agregados
            </a>
          </li>
        )}

        {props.permitirVisualiarSimilares && (
          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaSimilares()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_Similares">
              Similares
            </a>
          </li>
        )}

        {props.permitirVisualiarOfertas && (
          <li>
            <a
              href="#"
              onClick={() => {
                props.onRenderizarConsultaOfertas()
                props.onSelecionadoMenu();
              }}
              id="MenuConsultaProdutos_Ofertas">
              Ofertas
            </a>
          </li>
        )}

        {props.permitirVisualiarLotesProdutos && (
          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaLotesProdutos()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_LotesProdutos">
              {props.orcamentoControlaValidade ? "Lotes/Validade" : "Lotes"}
            </a>
          </li>
        )}

        {props.permitirVisualiarLotesProdutosReservados && (
          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaLotesProdutosReservados()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_LotesProdutosReservados">
              {props.orcamentoControlaValidade ? "Lotes/Validade Reservados" : "Lotes Reservados"}
            </a>
          </li>
        )}

        {props.permitirVisualizarOrdemProducao && (

          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaOrdemProducao()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_OrdemProducao">
              Ordem Produção
            </a>
          </li>
        )}

        {props.permitirVisualiarAgregadosESugerirProdutos && (
          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaSugerirProdutos()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_SugerirProdutos">
              Sugerir Produtos
            </a>
          </li>
        )}

        {props.permitirVisualiarTributacao && (

          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaTributacao()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_Tributacao">
              Tributação
            </a>
          </li>
        )}

        {props.permitirVisualiarMovimentacaoEstoque && (

          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaMovimentacaoEstoque()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_MovimentacaoEstoque">
              Movimentação Estoque
            </a>
          </li>
        )}

        {props.permitirVisualizarUltimasCompras && (

          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaUltimasCompras()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_UltimasCompras">
              Última Compra
            </a>
          </li>
        )}

        {props.permitirVisualiarMedidasMadeira && (

          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaMedidasMadeira()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_MedidasMadeira">
              Medidas
            </a>
          </li>
        )}

        {props.permitirVisualizarConsultaTinta && (
          <li>
            <a href="#" onClick={() => {
              props.onRenderizarConsultaTinta()
              props.onSelecionadoMenu();
            }}
              id="MenuConsultaProdutos_Tinta">
              Tinta
            </a>
          </li>
        )}

        {props.permitirVisualiarAnaliseGerencial && ( // 433081
          <li>
            <a href="#"
              id="MenuConsultaProdutos_AnaliseGerencial"
              onClick={() => {
                props.onRenderizarConsultaAnaliseGerencial()
                props.onSelecionadoMenu();

              }}>
              Análise Gerencial
            </a>
          </li>
        )}

          {/* { 
          <li>
            <a href="#" 
            id="ServicosAgregados"
            onClick={() => {
              props.onRenderizarConsultaServicosAgregados()
              props.onSelecionadoMenu();
              
            }}>
              Servicos Agregados
            </a>
          </li>
        } */}

      </ul>

      {<section style={{ marginBottom: "30px" }} />}
    </>
  );
};
